(() => {
  const placeWa = () => {
    const wa = document.querySelector('.is-wa-dock');
    const banner = document.querySelector('.is-cookie-consent__banner');
    if (!wa) return;
    const open = banner && !banner.hasAttribute('hidden') && banner.getClientRects().length > 0;
    wa.style.bottom = open ? `${Math.round(banner.getBoundingClientRect().height + 16)}px` : '';
  };
  placeWa();
  window.addEventListener('resize', placeWa);
  document.addEventListener('click', () => setTimeout(placeWa, 50));
  const banner = document.querySelector('.is-cookie-consent__banner');
  if (banner && window.MutationObserver) {
    new MutationObserver(placeWa).observe(banner, { attributes: true, attributeFilter: ['hidden', 'class', 'style'] });
  }

  const modelInput = document.querySelector('[data-quote-model]');
  if (modelInput && !modelInput.value) {
    const model = new URLSearchParams(location.search).get('model');
    if (model) modelInput.value = model;
  }

  const fitRoot = document.querySelector('[data-desk-fit]');
  if (fitRoot) {
    const widthInput = fitRoot.querySelector('[data-fit-width]');
    const useInput = fitRoot.querySelector('[data-fit-use]');
    const cards = [...fitRoot.querySelectorAll('[data-fit-card]')];
    const empty = fitRoot.querySelector('[data-fit-empty]');
    const heading = fitRoot.querySelector('[data-fit-heading]');

    const labelFor = (size) => {
      const en = document.documentElement.lang === 'en';
      if (size === 'small') return en ? 'For a compact desk' : 'Kompakt masa için';
      if (size === 'large') return en ? 'For an executive desk' : 'Makam masası için';
      return en ? 'For a mid-width desk' : 'Orta genişlikte masa için';
    };

    const pick = () => {
      const width = Number(widthInput?.value || 0);
      const use = useInput?.value || 'mixed';
      fitRoot.classList.toggle('is-idle', !width);
      let size = 'mid';
      if (width) {
        if (width < 140) size = 'small';
        else if (width >= 170) size = 'large';
        if (use === 'laptop' && size === 'large') size = 'mid';
        if (use === 'evrak' && size === 'small') size = 'mid';
      }
      cards.forEach((card) => card.classList.toggle('is-on', card.dataset.size === size));
      if (heading) {
        heading.classList.remove('visually-hidden');
        heading.textContent = width ? labelFor(size) : labelFor('mid');
      }
      if (empty) empty.hidden = true;
    };
    widthInput?.addEventListener('input', pick);
    useInput?.addEventListener('change', pick);
    pick();
  }
})();
